// data-testid registry for the Paliwal Medicos site
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkCategories: "nav-link-categories",
  linkContact: "nav-link-contact",
  linkFaq: "nav-link-faq",
  callBtn: "nav-call-btn",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  callBtn: "hero-call-btn",
  whatsappBtn: "hero-whatsapp-btn",
  directionsBtn: "hero-directions-btn",
};

export const CATEGORY = {
  searchInput: "category-search-input",
  card: (slug) => `category-card-${slug}`,
  empty: "category-empty-state",
};

export const RX = {
  dropzone: "prescription-dropzone",
  nameInput: "prescription-name-input",
  mobileInput: "prescription-mobile-input",
  noteInput: "prescription-note-input",
  submitBtn: "prescription-submit-btn",
  removeBtn: "prescription-remove-btn",
};

export const CONTACT = {
  nameInput: "contact-name-input",
  mobileInput: "contact-mobile-input",
  emailInput: "contact-email-input",
  messageInput: "contact-message-input",
  submitBtn: "contact-submit-btn",
  directionsBtn: "contact-directions-btn",
};

export const FAQ = {
  item: (i) => `faq-item-${i}`,
};

export const FLOAT = {
  call: "floating-call-btn",
  whatsapp: "floating-whatsapp-btn",
  top: "back-to-top-btn",
};
